import { render, staticRenderFns } from "./stripe-wallet-widget-page.vue?vue&type=template&id=8ceed1f4&"
import script from "./stripe-wallet-widget-page.vue?vue&type=script&lang=js&"
export * from "./stripe-wallet-widget-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports